export default __webpack_public_path__ + "static/media/careerAdviseImg.2e5c89fe.png";